import * as IF from "infrontjs";
import { getSettings, setSetting } from '../data/settings.js';
import { trackPageView } from '../data/analytics.js';
import { setMusicEnabled } from '../data/audio.js';

const BACK_SVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6 L9 12 L15 18"/></svg>`;
const CHEV_SVG = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="pmset-row__chev"><path d="M9 6 L15 12 L9 18"/></svg>`;

const ICON_STATS    = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 19 V11"/><path d="M10 19 V5"/><path d="M16 19 V8"/><path d="M22 19 V14"/><path d="M3 22 H22"/></svg>`;
const ICON_SFX      = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4 L6 9 H3 v6 h3 l5 5 Z"/><path d="M16 9 a4 4 0 0 1 0 6"/><path d="M19 6 a8 8 0 0 1 0 12"/></svg>`;
const ICON_MUSIC    = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18 V6 L20 4 V16"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/></svg>`;
const ICON_COOKIE   = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12 a9 9 0 1 1 -9 -9 a4 4 0 0 0 4 4 a4 4 0 0 0 4 4 a4 4 0 0 0 1 1 Z"/><circle cx="9"  cy="10" r="0.6" fill="currentColor"/><circle cx="13" cy="14" r="0.6" fill="currentColor"/><circle cx="9"  cy="16" r="0.6" fill="currentColor"/><circle cx="16" cy="11" r="0.6" fill="currentColor"/></svg>`;
const ICON_DANGER   = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9 V13"/><circle cx="12" cy="16.5" r="0.6" fill="currentColor"/><path d="M10.3 3.6 L2.5 17 a2 2 0 0 0 1.7 3 H19.8 a2 2 0 0 0 1.7 -3 L13.7 3.6 a2 2 0 0 0 -3.4 0 Z"/></svg>`;
const ICON_WARN_LG  = `<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9 V13"/><circle cx="12" cy="16.5" r="0.6" fill="currentColor"/><path d="M10.3 3.6 L2.5 17 a2 2 0 0 0 1.7 3 H19.8 a2 2 0 0 0 1.7 -3 L13.7 3.6 a2 2 0 0 0 -3.4 0 Z"/></svg>`;
const ICON_CHECK_LG = `<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5 L10 17.5 L19 7.5"/></svg>`;
const ICON_CHECK_SM = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12 L10 18 L20 6"/></svg>`;
const ICON_TRASH    = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6 H21"/><path d="M8 6 V4 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 v2"/><path d="M5 6 L6 20 a2 2 0 0 0 2 2 h8 a2 2 0 0 0 2 -2 L19 6"/></svg>`;


function toggleHtml( id, checked, ariaLabel )
{
    return `<button type="button" id="${ id }" role="switch" aria-checked="${ checked ? 'true' : 'false' }" aria-label="${ ariaLabel }" class="pmset-toggle ${ checked ? 'is-on' : 'is-off' }">
        <span class="pmset-toggle__track" aria-hidden="true">
            <span class="pmset-toggle__thumb"></span>
        </span>
    </button>`;
}

function rowHtml( { icon, title, description, ctrlHtml } )
{
    return `<div class="pmset-row">
        <div class="pmset-row__icon">${ icon }</div>
        <div class="pmset-row__body">
            <div class="pmset-row__title">${ title }</div>
            ${ description ? `<div class="pmset-row__desc">${ description }</div>` : '' }
        </div>
        <div class="pmset-row__ctrl">${ ctrlHtml }</div>
    </div>`;
}

function linkRowHtml( { id, icon, title, description } )
{
    return `<button type="button" class="pmset-row pmset-row--link" id="${ id }">
        <div class="pmset-row__icon">${ icon }</div>
        <div class="pmset-row__body">
            <div class="pmset-row__title">${ title }</div>
            ${ description ? `<div class="pmset-row__desc">${ description }</div>` : '' }
        </div>
        <div class="pmset-row__ctrl">${ CHEV_SVG }</div>
    </button>`;
}


export class SettingsState extends IF.State
{
    static ID = 'settings';
    static ROUTE = '/settings';

    async enter()
    {
        trackPageView( 'SettingsState', '/settings' );

        const appEl = document.getElementById( 'app' );
        const gameEl = document.getElementById( 'game-container' );
        appEl.classList.add( 'active' );
        gameEl.classList.remove( 'active' );

        this._render();
    }

    _render()
    {
        const s = getSettings();

        this.app.view.renderHtml( this.app.container, `
            <div class="pmset">
                <header class="pmset__top">
                    <button class="pmset__back" id="pmset-back" type="button" aria-label="Back">${ BACK_SVG }</button>
                    <div class="pmset__title">Settings</div>
                    <div class="pmset__topSpacer" aria-hidden="true"></div>
                </header>

                <div class="pmset__scroll">
                    <section class="pmset-group">
                        <div class="pmset-group__eyebrow">Tracking</div>
                        <div class="pmset-group__rows">
                            ${ rowHtml({
                                icon: ICON_STATS,
                                title: 'Enable stats',
                                description: 'When off, your levels still play normally &mdash; but no fields cleared, mines defused, ratios or play time will be recorded.',
                                ctrlHtml: toggleHtml( 'pmset-toggle-stats', s.stats, 'Enable stats' ),
                            }) }
                        </div>
                    </section>

                    <section class="pmset-group">
                        <div class="pmset-group__eyebrow">Audio</div>
                        <div class="pmset-group__rows">
                            ${ rowHtml({
                                icon: ICON_SFX,
                                title: 'Sound effects',
                                description: 'Taps, defuses, and the level-finish chime.',
                                ctrlHtml: toggleHtml( 'pmset-toggle-sfx', s.sfx, 'Sound effects' ),
                            }) }
                            ${ rowHtml({
                                icon: ICON_MUSIC,
                                title: 'Music',
                                description: 'Looping ambient soundtrack.',
                                ctrlHtml: toggleHtml( 'pmset-toggle-music', s.music, 'Music' ),
                            }) }
                        </div>
                    </section>

                    <section class="pmset-group">
                        <div class="pmset-group__eyebrow">Privacy</div>
                        <div class="pmset-group__rows">
                            ${ linkRowHtml({
                                id: 'pmset-cookies',
                                icon: ICON_COOKIE,
                                title: 'Cookie settings',
                                description: 'Manage tracking and analytics consent.',
                            }) }
                        </div>
                    </section>

                    <section class="pmset-group">
                        <div class="pmset-group__eyebrow">Danger zone</div>
                        <div class="pmset-danger">
                            <div class="pmset-danger__head">
                                <span class="pmset-danger__warn" aria-hidden="true">${ ICON_DANGER }</span>
                                <div>
                                    <div class="pmset-danger__title">Delete all data</div>
                                    <p class="pmset-danger__desc">
                                        Permanently removes your level progress, ranks, hearts, stats and settings from this device.
                                        <strong>This cannot be undone.</strong>
                                    </p>
                                </div>
                            </div>
                            <button class="pmset-danger__btn" id="pmset-delete" type="button">
                                ${ ICON_TRASH }
                                Delete all data
                            </button>
                        </div>
                    </section>
                </div>

                <div class="pmset-confirm" id="pmset-confirm" aria-hidden="true">
                    <button class="pmset-confirm__scrim" id="pmset-confirm-scrim" type="button" aria-label="Cancel" tabindex="-1"></button>
                    <div class="pmset-confirm__card" role="dialog" aria-modal="true" aria-labelledby="pmset-confirm-title">
                        <div class="pmset-confirm__icon">${ ICON_WARN_LG }</div>
                        <h3 class="pmset-confirm__title" id="pmset-confirm-title">Delete all data?</h3>
                        <p class="pmset-confirm__body">
                            This wipes <strong>everything</strong> &mdash; your level progress, ranks, stats, hearts and settings.
                            It can't be recovered.
                        </p>
                        <div class="pmset-confirm__actions">
                            <button class="pmset-confirm__cancel"  id="pmset-confirm-cancel"  type="button">Keep my data</button>
                            <button class="pmset-confirm__confirm" id="pmset-confirm-confirm" type="button">
                                ${ ICON_TRASH }
                                Delete forever
                            </button>
                        </div>
                    </div>
                </div>

                <div class="pmset-confirm pmset-confirm--success" id="pmset-success" aria-hidden="true">
                    <button class="pmset-confirm__scrim" id="pmset-success-scrim" type="button" aria-label="Close" tabindex="-1"></button>
                    <div class="pmset-confirm__card" role="dialog" aria-modal="true" aria-labelledby="pmset-success-title">
                        <div class="pmset-confirm__icon pmset-confirm__icon--ok">${ ICON_CHECK_LG }</div>
                        <h3 class="pmset-confirm__title" id="pmset-success-title">All clear!</h3>
                        <p class="pmset-confirm__body">
                            Your data has been wiped from this device. You're starting fresh &mdash; happy defusing.
                        </p>
                        <div class="pmset-confirm__actions pmset-confirm__actions--single">
                            <button class="pmset-confirm__ok" id="pmset-success-ok" type="button">
                                ${ ICON_CHECK_SM }
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this._wire();
    }

    _wire()
    {
        document.getElementById( 'pmset-back' ).addEventListener( 'click', () =>
        {
            this.app.router.redirect( '/' );
        });

        const wireToggle = ( id, key ) =>
        {
            const el = document.getElementById( id );
            el.addEventListener( 'click', () =>
            {
                const next = !el.classList.contains( 'is-on' );
                el.classList.toggle( 'is-on', next );
                el.classList.toggle( 'is-off', !next );
                el.setAttribute( 'aria-checked', next ? 'true' : 'false' );
                setSetting( key, next );
                if ( key === 'music' ) setMusicEnabled( next );
            });
        };
        wireToggle( 'pmset-toggle-stats', 'stats' );
        wireToggle( 'pmset-toggle-sfx',   'sfx' );
        wireToggle( 'pmset-toggle-music', 'music' );

        document.getElementById( 'pmset-cookies' ).addEventListener( 'click', () =>
        {
            window.cookieConsent?.open();
        });

        const confirmEl = document.getElementById( 'pmset-confirm' );
        const successEl = document.getElementById( 'pmset-success' );
        const openConfirm  = () => { confirmEl.classList.add( 'is-open' );    confirmEl.setAttribute( 'aria-hidden', 'false' ); };
        const closeConfirm = () => { confirmEl.classList.remove( 'is-open' ); confirmEl.setAttribute( 'aria-hidden', 'true' ); };
        const openSuccess  = () => { successEl.classList.add( 'is-open' );    successEl.setAttribute( 'aria-hidden', 'false' ); };
        const closeSuccess = () => { successEl.classList.remove( 'is-open' ); successEl.setAttribute( 'aria-hidden', 'true' ); };

        document.getElementById( 'pmset-delete' ).addEventListener( 'click', openConfirm );
        document.getElementById( 'pmset-confirm-cancel' ).addEventListener( 'click', closeConfirm );
        document.getElementById( 'pmset-confirm-scrim'  ).addEventListener( 'click', closeConfirm );

        document.getElementById( 'pmset-confirm-confirm' ).addEventListener( 'click', () =>
        {
            // Wipe every key in localStorage — progress, hearts, coins, stats,
            // settings, the lot. Settings re-render below picks up defaults.
            try { localStorage.clear(); }
            catch ( e ) { console.error( 'localStorage.clear failed', e ); }

            closeConfirm();
            this._render();
            // _render rebuilt the DOM, so re-grab the success element.
            const newSuccess = document.getElementById( 'pmset-success' );
            newSuccess.classList.add( 'is-open' );
            newSuccess.setAttribute( 'aria-hidden', 'false' );
        });

        document.getElementById( 'pmset-success-ok'    ).addEventListener( 'click', closeSuccess );
        document.getElementById( 'pmset-success-scrim' ).addEventListener( 'click', closeSuccess );
    }

    async exit()
    {
        this.app.container.innerHTML = '';
        document.getElementById( 'app' ).classList.remove( 'active' );
    }
}
